module.exports = __webpack_public_path__ + "img/icon_map_108_off_110.dac0ac14.png";